import { render, staticRenderFns } from "./Addsupplier.vue?vue&type=template&id=1d1b1c1a&"
import script from "./Addsupplier.vue?vue&type=script&lang=js&"
export * from "./Addsupplier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports